import { Component, HostListener, OnDestroy } from '@angular/core'
import { SelectionModel } from '@angular/cdk/collections'
import { distinctUntilChanged, map, Observable, Subject, switchMap, takeUntil } from 'rxjs'
import { Select } from '@ngxs/store'
import { QuoteSessionState } from '@app/shared/store/quote-session/quote-session.state'
import { Contact } from '@app/models/contact'

enum SelectedSidebar {
	Quote = 'quote',
	SalesProcessTool = 'tool',
	Notes = 'notes',
	History = 'history',
}

@Component({
	selector: 'app-drawer',
	templateUrl: './drawer.component.html',
	styleUrls: ['./drawer.component.scss'],
})
export class DrawerComponent implements OnDestroy {
	@Select(QuoteSessionState.contactState)
	public contactState$!: Observable<Contact>

	public Sidebar = SelectedSidebar
	public model = new SelectionModel(false, [
		SelectedSidebar.Quote,
		SelectedSidebar.SalesProcessTool,
		SelectedSidebar.Notes,
		SelectedSidebar.History,
	])
	public isOpen: boolean = true
	public sessionStarted$: Observable<boolean>

	#ngUnsubscribe$: Subject<void> = new Subject()

	public get currentSelection(): SelectedSidebar {
		return this.model.selected[0]
	}

	constructor() {
		this.sessionStarted$ = this.contactState$.pipe(map((c) => !!c?.ratingState))

		this.model.changed.pipe(takeUntil(this.#ngUnsubscribe$)).subscribe((e) => {
			this.isOpen ||= true
		})
	}

	public changeSelection(value: SelectedSidebar): void {
		const sameAsCurrent = this.model.selected[0] === value
		sameAsCurrent && this.toggleDrawer()
		this.model.select(value)
	}

	public hideDrawer(): void {
		this.isOpen = false
	}

	public toggleDrawer(): void {
		this.isOpen = !this.isOpen
	}

	@HostListener('keydown.escape')
	public onEscapeKey(): void {
		if (this.isOpen) {
			this.hideDrawer()
		}
	}

	ngOnDestroy(): void {
		this.#ngUnsubscribe$.next()
		this.#ngUnsubscribe$.unsubscribe()
	}
}
